const graphqlUrl = '/graphql/v1/';

export const getProducts = async (searchInput) => {
    const productsQuery = JSON.stringify({
        query: `query {
            products(${searchInput}) {
                results {
                    resultCount
                    resultPage
                    currentPage
                    limitPerPage
                }
                products {
                    id
                    code
                    name
                    link
                    icon
                    description
                    price {
                        price {
                            gross {
                                value
                                currency
                                formatted
                            }
                            net {
                                value
                                currency
                                formatted
                            }
                        }
                        lastPriceChangeDate
                    }
                    sizes {
                        id
                        name
                        amount
						codeExtern
                        availability {
                            visible
                            description
                            status
                            icon
                        }
						price {
							price {
								gross {
									value
									currency
									formatted
								}
								net {
									value
									currency
									formatted
								}
							}
                            beforeRebate {
								gross {
									value
									currency
									formatted
								}
								net {
									value
									currency
									formatted
								}
							}
						}
                    }
                    unit {
                        name
                        sellBy
                    }
                    awardedParameters {
                        id
                        name
                        values {
                            name
                        }
                    }
                }
            }
        }`,
    });

    try {
        const response = await fetch(graphqlUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: productsQuery,
        });
        const dataJson = await response.json();
        return dataJson;
    } catch (error) {
        console.error('AJAX fetchProducts() Error:', error);
        return false;
    }
};

export const getLowestPrice = async (lowestPriceInput) => {
    const lowestPriceQuery = JSON.stringify({
        query: `query {
            getLastLowestProductPrices(${lowestPriceInput}) {
                id
                sizes {
                    id
                    price {
                        gross {
                            value
                            currency
                            formatted
                        }
                    }
                }
            }
        }`,
    });

    try {
        const response = await fetch('/graphql/v1/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: lowestPriceQuery,
        });
        const dataJson = await response.json();
        return dataJson;
    } catch (error) {
        console.error('AJAX fetchLastLowestProductPrices() Error:', error);
        return false;
    }
};